
/* injects from baggage-loader */

import React, { Component } from "react";
import PropTypes from "prop-types";
import StandartGame from "../standartGame";
import moment from "moment";
import Config from "../../../config/main";

class GamesWrapperStandart extends Component {
    render () {
        let { compName, selectorKey, gameType, sportAlias, regionAlias } = this.props;
        if (compName) {
            if (sportAlias !== 'boosted') {
                let days = Object.keys(compName);
                return days.map((day) => {
                    return <>
                        {Config.enableStandardGameListDateGrouping && <div className="game-date-view-m">
                            <p className="date-view-list-g">{moment.unix(day).format(Config.main.dateFormat)}</p>
                        </div>}

                        {compName[day].sort((a, b) => a.start_ts - b.start_ts).map((game) => {
                            return <StandartGame key={game.gameid}
                                                 gameId={game.gameid}
                                                 selectorKey={selectorKey}
                                                 gameType={gameType}
                                                 start_ts={game.start_ts}
                                                 sportAlias={sportAlias}/>;
                        })}
                    </>;
                });
            } else {
                return compName[regionAlias].map((game) => {
                    return <StandartGame key={game}
                        gameId={game}
                        selectorKey={selectorKey}
                        start_ts={compName.start_ts}
                        gameType={gameType}
                        sportAlias={compName.sportAlias} />;
                });
            }
        } else {
            return null;
        }
    }
}

GamesWrapperStandart.propTypes = {
    selectorKey: PropTypes.string,
    compName: PropTypes.string,
    data: PropTypes.object,
    gameType: PropTypes.string,
    sportAlias: PropTypes.string
};

// const mapStateToProps = (_, ownParams) => {
//     let {selectorKey, compName} = ownParams;
//     return createSelector(
//         [
//             state => state.standartGameList[selectorKey] && JSON.stringify((() => {
//                 let data = {};
//                 Helpers.objectToArray(state.standartGameList[selectorKey]).sort((a, b) => a.start_ts - b.start_ts).forEach((game) => {
//                     if (compName === game.competitionName) {
//                         let day = moment.unix(game.start_ts).dayOfYear();
//                         data[day] = data[day] || [];
//                         data[day].push(game.id);
//                     }
//                 });
//                 return data;
//             })())
//         ],
//         (data) => {
//             return {
//                 data: data && JSON.parse(data)
//             };
//         });
// };

export default GamesWrapperStandart;